import React from 'react';

function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-grid"></div>
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Workforce Management Reimagined
          </div>
          <h1>
            Build Smarter <span className="highlight">Rosters.</span>
            <br />
            Run Better Teams.
          </h1>
          <p className="hero-description">
            The intelligent platform that automates scheduling, tracks attendance,
            manages shifts and streamlines your entire workforce operations — all in one place.
          </p>
          <div className="hero-buttons">
            <a href="https://9works.in/organisation-portal" className="btn btn-primary btn-large" target="_blank" rel="noopener noreferrer">
              Get Started
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <a href="#features" className="btn btn-ghost btn-large">
              Explore Features
            </a>
          </div>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-value">98%</div>
              <div className="hero-stat-label">Scheduling Accuracy</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-value">60%</div>
              <div className="hero-stat-label">Time Saved on Roster</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-value">24/7</div>
              <div className="hero-stat-label">Real-time Monitoring</div>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-dashboard">
            <div className="dashboard-header">
              <div className="dashboard-dot red"></div>
              <div className="dashboard-dot yellow"></div>
              <div className="dashboard-dot green"></div>
              <span className="dashboard-title">9works Dashboard</span>
            </div>
            <div className="dashboard-row">
              <div className="dashboard-card">
                <div className="dashboard-card-label">Active Staff</div>
                <div className="dashboard-card-value">1,247</div>
              </div>
              <div className="dashboard-card">
                <div className="dashboard-card-label">On Shift Now</div>
                <div className="dashboard-card-value green">892</div>
              </div>
              <div className="dashboard-card">
                <div className="dashboard-card-label">On Leave</div>
                <div className="dashboard-card-value">48</div>
              </div>
            </div>
            <div className="dashboard-card" style={{ marginBottom: 0 }}>
              <div className="dashboard-card-label">Shift Coverage This Week</div>
              <div className="dashboard-bar-group">
                <div className="dashboard-bar-row">
                  <span className="dashboard-bar-label">Mon</span>
                  <div className="dashboard-bar-track"><div className="dashboard-bar-fill" style={{ width: '96%' }}></div></div>
                  <span className="dashboard-bar-percent">96%</span>
                </div>
                <div className="dashboard-bar-row">
                  <span className="dashboard-bar-label">Tue</span>
                  <div className="dashboard-bar-track"><div className="dashboard-bar-fill" style={{ width: '100%' }}></div></div>
                  <span className="dashboard-bar-percent">100%</span>
                </div>
                <div className="dashboard-bar-row">
                  <span className="dashboard-bar-label">Wed</span>
                  <div className="dashboard-bar-track"><div className="dashboard-bar-fill" style={{ width: '92%' }}></div></div>
                  <span className="dashboard-bar-percent">92%</span>
                </div>
                <div className="dashboard-bar-row">
                  <span className="dashboard-bar-label">Thu</span>
                  <div className="dashboard-bar-track"><div className="dashboard-bar-fill" style={{ width: '88%' }}></div></div>
                  <span className="dashboard-bar-percent">88%</span>
                </div>
                <div className="dashboard-bar-row">
                  <span className="dashboard-bar-label">Fri</span>
                  <div className="dashboard-bar-track"><div className="dashboard-bar-fill" style={{ width: '94%' }}></div></div>
                  <span className="dashboard-bar-percent">94%</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-float hero-float-1">
            <span className="float-dot green"></span>
            Shift approved
          </div>
          <div className="hero-float hero-float-2">
            <span className="float-dot blue"></span>
            Leave request
          </div>
          <div className="hero-float hero-float-3">
            <span className="float-dot amber"></span>
            New roster published
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
